export default __webpack_public_path__ + "static/media/playButton.f3b32b96.svg";